export default {
  init() {
    const menuButton = document.querySelector('.menu-button');
    menuButton.addEventListener('click', () => {
      let menu = document.querySelector('.navigation');
      menu.classList.toggle('hidden');
    })
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js